<template>
    <div class="gauge-container" ref="gaugeContainer"></div>
</template>

<script>
  import echarts from "echarts"
  export default {
    name: "gaugeChart",
    props: {
        receiveData: {
          type: Number,     // 仪表盘百分比值
        },
        title: {
          type: String,     // 仪表盘标题
          default: ""
        },
        name: {
          type: String,     // 仪表盘名称
          default: ""
        },
        color: {
          type: Array,      // 仪表盘颜色
          default: () => {
            return [[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']];
          }
        }
    },
    methods: {
        loadFunnel() {
          // 绘制仪表盘
          let option = {
            tooltip: {
              formatter: '{a} <br/>{b} : {c}%'
            },
            series: [
              {
                name: this.name,
                radius: '90%',
                type: 'gauge',
                detail: {
                  formatter: '{value}%',
                  fontSize: "15",
                  fontFamily:  'Microsoft YaHei',
                  padding: [40,0,0,0]
                },
                data: [{value: this.receiveData, name: this.title}],
                axisLabel: {
                  fontSize: "10"
                },
                axisTick: {
                  length: 3
                },
                axisLine: {
                  lineStyle: {
                    width: 15,
                    color: this.color
                  }
                },
                pointer: {
                  length: "60%"
                },
                splitLine: {
                  length: 15
                },
                title: {
                  fontSize: "15",
                  fontFamily:  'Microsoft YaHei',
                  offsetCenter: [0, "100%"]
                }
              }
            ]
          };
          let myChart = this.$refs.gaugeContainer;
          echarts.init(myChart).setOption(option, true);
        }
    },
    watch: {
      receiveData(val) {
        if(typeof val !== "undefined") {
          this.loadFunnel();
        }
      }
    },
    mounted() {
      // window.resize = () => {
      //   return !function() {
      //     this.loadFunnel();
      //   }
      // }
      this.loadFunnel();
    }
  };
</script>

<style scoped>
    .gauge-container {
        width: 100%;
        height: 100%;
    }
</style>